
/***
Faux Selector Functionality
***/

function updateFauxSelector(selectedElement) {
  var parentDropdownPane = selectedElement.closest('.dropdown-pane');
  var selectorWrapper = selectedElement.closest('.faux-select-wrapper');
  var selectorLauncher = selectorWrapper.find('.launcher');
  var thisText = selectedElement.text();
  var thisValue = selectedElement.data('value');
  console.log('option changed: ' + thisText + ' - ' + thisValue);
  parentDropdownPane.foundation('close');
  if (thisValue!='') {
    selectorLauncher.text(thisText);
    selectorWrapper.find('input[type="hidden"]').val(thisValue);
  } else {
    resetText = selectorLauncher.data('reset');
    selectorLauncher.text(resetText);
    selectorWrapper.find('input[type="hidden"]').val('');
  }
}

function loadFauxSelector() {
  $('.faux-selector-field').each(function( index ) {
    if ($(this).val()!='') {
      var valText = $(this).parent().find('.faux-selector-option[data-value="' + $(this).val() + '"]').text();
      console.log('test: ' + $(this).val() + ': ' + valText);
      $(this).parent().find('.launcher').text(valText);
    }
  });
}

jQuery(document).ready(function($){
  // Deal with pre-populated fields
  loadFauxSelector();
  // Deal with clicks
  $('.faux-selector-option').on('click',function() {
    updateFauxSelector($(this));
  });
});
